var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screener-question-checkbox"},[_c('v-checkbox',{attrs:{"dense":"","value":"true","hide-details":"auto"},on:{"change":function($event){return _vm.onChange()}},model:{value:(_vm.checkVal),callback:function ($$v) {_vm.checkVal=$$v},expression:"checkVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }